import { memo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './passkeyInformationBarContents.module.scss';

const PasskeyInformationBarContents = ({ containerClass, onClick }) => {
  return (
    <div className={classNames(styles.wrapper, containerClass)}>
      <span className={styles.text}>パスキー未作成の方は今すぐ作成！</span>
      <button type="button" className={styles.button} onClick={onClick}>
        登録
        <i className={classNames('material-icons', styles.buttonIcon)}>open_in_new</i>
      </button>
    </div>
  );
};

PasskeyInformationBarContents.propTypes = {
  containerClass: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

PasskeyInformationBarContents.defaultProps = {
  containerClass: undefined,
};
export default memo(PasskeyInformationBarContents);
